export default {"src":"/_next/static/media/extended_lifespan.1132fc9f.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};